import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { changeFormField } from 'apps/auth/actions/formAction';
import { Text } from 'apps/auth/components/common/Text/Text';
import { validationAndUpdateValue } from 'apps/auth/components/form-multi/utils';

const SwitchInputBlock = styled.div`
    padding: 20px 0;
    display: flex;
    justify-content: space-between;
`;
const SwitchCheckbox = styled.input`
    opacity: 0;
    position: absolute;
    z-index: -1;
`;
const SwitchControl = styled.label`
    display: inline-block;
    position: relative;
    width: 48px;
    height: 28px;
    margin-left: 24px;
    cursor: ${(props) => (props.$isDisabled ? 'default' : 'pointer')};

    &::before {
        background-color: var(--bg_tertiary_default);
        border-radius: 14px;
        content: '';
        height: 100%;
        right: 0;
        position: absolute;
        top: 0;
        width: 100%;
        transition-duration: 0.15s;
        transition-property: background-color;
    }

    &::after {
        background-color: ${(props) => props.theme.white};
        border-radius: 50%;
        content: '';
        height: 20px;
        left: 4px;
        position: absolute;
        top: 4px;
        width: 20px;
    }
`;
const SwitchWrapper = styled.div`
    opacity: ${(props) => (props.$isDisabled ? '0.4' : null)};
    pointer-events: ${(props) => (props.$isDisabled ? 'none' : null)};

    ${SwitchCheckbox}:checked + ${SwitchInputBlock} ${SwitchControl} {
        &::before {
            background-color: var(--green-100);
        }

        &::after {
            left: auto;
            right: 4px;
        }
    }
`;

const SwitchInput = ({ field, formName, changeFormField, onChangeHandler, ...props }) => {
    const handlerClick = (e) => {
        e.preventDefault();
        const value = field.value === 'false' && typeof field.value === 'string' ? false : field.value;
        validationAndUpdateValue(formName, !value, field, changeFormField).then(() => {
            if (onChangeHandler) {
                onChangeHandler();
            }
        });
    };

    const isChecked = field.value === 'true' || field.value === true;
    return (
        <SwitchWrapper $isDisabled={props.isDisabled}>
            <SwitchCheckbox name={field.name} type="checkbox" checked={isChecked} onChange={() => {}} />
            <SwitchInputBlock onClick={handlerClick}>
                <Text variant="div">{field.placeholder}</Text>
                <SwitchControl $isDisabled={props.isDisabled} />
            </SwitchInputBlock>
        </SwitchWrapper>
    );
};

SwitchInput.propTypes = {
    isDisabled: PropTypes.bool,
};

export default connect(null, { changeFormField })(SwitchInput);
